<template>
  <a-modal
    v-bind="$attrs"
    v-on="$listeners"
    :visible="visible"
    @cancel="handleCancel"
  >
    <template slot="footer">
      <a-button key="cancel" :loading="loading" @click="handleCancel">
        取消
      </a-button>
      <a-button key="submit" type="primary" :loading="loading" @click="handleOk">
        确定
      </a-button>
    </template>
    <a-form v-bind="formItemLayout" :form="modifyForm" @submit="handleOk">
      <a-form-item label="银行">
        <a-select
          class="modal-form"
          placeholder="请选择银行"
          showSearch
          optionFilterProp="label"
          v-decorator="
           ['bankCode', { rules: [{ required: true, validateTrigger: 'change', type: 'string', message: '银行不能为空' }] }]"
        >
          <a-select-option v-for="(it, id) in bankList" :key="id" :value="it.bankCode" :label="it.bankName">{{it.bankName}}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="swift code">
        <a-input
          placeholder="请输入swift code"
          class="modal-form"
          v-decorator="
           ['swiftCode', { rules: [{ required: true, type: 'string', message: 'swift code不能为空' }] }]"
        ></a-input>
      </a-form-item>
      <a-form-item label="最小位数">
        <a-input-number
          class="modal-form"
          placeholder="请输入最小位数"
          v-decorator="
           ['min', { rules: [{ required: true, validateTrigger: 'change', type: 'number', message: '最小位数不能为空' }] }]"
        >
        </a-input-number>
      </a-form-item>
      <a-form-item label="最大位数">
        <a-input-number
          class="modal-form"
          placeholder="请输入最大位数"
          v-decorator="
           ['max', { rules: [{ required: true, validateTrigger: 'change', type: 'number', message: '最大位数不能为空' }] }]"
        >
        </a-input-number>
      </a-form-item>
      <a-form-item label="账号前缀">
        <a-input
          placeholder="请输入账号前缀"
          class="modal-form"
          v-decorator="
           ['bankPrefix', { rules: [{ required: true, type: 'string', message: '账号前缀不能为空' }] }]"
        ></a-input>
      </a-form-item>
      <a-form-item label="账户名前缀">
        <a-input
          placeholder="请输入账户名前缀"
          class="modal-form"
          v-decorator="
           ['accountNamePrefix', { rules: [{ required: true, type: 'string', message: '账户名前缀不能为空' }] }]"
        ></a-input>
      </a-form-item>
      <a-form-item label="索引">
        <a-input
          placeholder="请输入索引"
          class="modal-form"
          v-decorator="
           ['accountIndex', { rules: [{ required: false, type: 'string', message: '索引不能为空' }] }]"
        ></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
// import { formItemLayout } from '@/config'

export default {
  name: 'CreateBank',
  props: {
    bankList: {
      type: Array
    }
  },
  data: () => ({
    visible: false,
    loading: false,
    modifyForm: null,
    formItemLayout: Object.freeze({
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 19
      }
    }),
    platList: [],
    startOpen: false,
    endOpen: false
  }),
  created () {
    this.modifyForm = this.$form.createForm(this, { name: 'modifyForm' })
  },
  methods: {
    // async getPlatList () {
    //   const response = await this.$http.business.receivePlatQueryList({})
    //   const { succ, data, msg } = response
    //   if (!succ) {
    //     this.$message.error(msg)
    //     return false
    //   } else {
    //     this.platList = data
    //   }
    // },
    handleCancel () {
      this.visible = false
      this.modifyForm.resetFields()
    },
    handleOk () {
      this.modifyForm.validateFields(async (err, values) => {
        if (!err) {
          const { bankCode } = values
          const { bankName } = this.bankList.find(it => it.bankCode === bankCode)
          const params = {
            ...values,
            bankName
          }
          this.loading = true
          const { succ } = await this.$http.business.vaBankAdd(params)
          this.loading = false
          if (succ) {
            this.$message.success('新增成功！')
            this.handleCancel()
            this.$emit('success')
          }
        }
      })
    },
    handleClose () {
      this.startOpen = false
      this.endOpen = false
    }
  }
}
</script>

<style scoped lang="less">
@import "~@/components/modal-form.less";
</style>
